import React from 'react';

import { getProduct } from '../../util/server-util';

export default function HiddenProduct() {
  const product = getProduct();
  return product ? <input type='hidden' name='product' value={product} /> : null;
}
